import React from 'react';

import { useTranslation, Trans } from "react-i18next";
import i18n from 'i18next'
import Fade from 'react-reveal/Fade'

import gr from '../../img/CompositeMesh/gr.webp';
import build from '../../img/CompositeMesh/build.webp'

import { Link } from "react-router-dom"

function ContactUs () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] xl:mx-auto relative">
                <div className='md:h-[322px] w-full bg-[#F26522] relative flex flex-col md:flex-row'>
                    <div className='flex flex-col items-center md:items-start justify-between mx-[20px] md:mx-[40px] xl:mx-[70px] mt-[40px] md:mt-0 md:py-[55px] md:mt-0'>
                        <p className='open-sans text-[28px] xl:text-[45px] text-[#1D1D1D] leading-[1.4]'>{t('CompositeMesh.14')}</p>
                        <p className='spanfont open-sans text-[#1D1D1D] text-[14px] xl:text-[20px] md:max-w-[250px] xl:max-w-[421px] text-center md:text-start mt-[15px] md:mt-0'><Trans>{t('CompositeMesh.15')}</Trans></p>
                        <Link to="/form" className='mt-[35px] md:mt-0'>
                            <div className="contactus !bg-[#1D1D1D] mr-auto hover:scale-[1.1] transition-all">
                                <p className="text-[#F6F6F6] montserrat font-[600] text-[14px] xl:text-[16px]">{t('CompositeReinforcement.5')}</p>
                            </div>
                        </Link>
                    </div>
                    <Fade right delay={500}><img src={gr} alt="" className='absolute md:relative bottom-0'/></Fade>
                    <Fade><img src={build} className={`md:absolute ${i18n.language === 'ar' ? 'left-0' : 'right-0'} bottom-[-1px] mt-[55px] md:mt-0`} alt="" /></Fade>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;